export default __webpack_public_path__ + "static/media/banner-4.3e4fac4a.jpg";